import React, { useEffect } from "react";
import { withStyles } from "@material-ui/core/styles";
import PlayerGame from "./PlayerGame";
import TeamGame from "./TeamGame";
import { Switch, Route } from "react-router-dom";
import { withRouter } from "react-router";
import { Paper, Typography } from "@material-ui/core";
import PlayerTournament from "./PlayerTournament";
import PlayerCareer from "./PlayerCareer";
import SchoolTotal from "./SchoolTotal";
import ShareButton from "../ShareButton";
import TeamTournament from "./TeamTournament";
import RecordList from "./RecordList";
import { DEFAULT_TITLE } from "../../constants";
import Game from "./Game";

const styles = theme => ({
  root: {
    maxWidth: 1200,
    marginTop: theme.spacing(5),
    padding: theme.spacing(2),
    overflowX: "auto",
    margin: "auto"
  }
});

function Record({ classes, match, location }) {
  let recordType = location.pathname.split("/")[2]?.split("-")[0];
  recordType = recordType
    ? recordType.charAt(0).toUpperCase() + recordType.slice(1)
    : "All";

  useEffect(() => {
    document.title = `${recordType} Records - ${DEFAULT_TITLE}`;
  });

  return (
    <Paper className={classes.root}>
      <div>
        <Typography variant="h4">
          {recordType} Records
          {recordType !== "All" && (
            <ShareButton pageType="leaderboard"></ShareButton>
          )}
        </Typography>
        {recordType === "All" && <RecordList></RecordList>}
        <Switch>
          <Route
            exact
            path={`${match.path}/individual-game`}
            component={PlayerGame}
          />
          <Route
            exact
            path={`${match.path}/individual-tournament`}
            component={PlayerTournament}
          />
          <Route
            exact
            path={`${match.path}/individual-career`}
            component={PlayerCareer}
          />
          <Route exact path={`${match.path}/team-game`} component={TeamGame} />
          <Route
            exact
            path={`${match.path}/team-tournament`}
            component={TeamTournament}
          />
          <Route exact path={`${match.path}/school`} component={SchoolTotal} />
          <Route exact path={`${match.path}/game`} component={Game} />
        </Switch>
      </div>
    </Paper>
  );
}

export default withRouter(withStyles(styles)(Record));
